export default __webpack_public_path__ + "static/media/how-it-works--desktop@2x.0de27ab9.webp";